import { render, staticRenderFns } from "./ImportWorkersAction.vue?vue&type=template&id=b08193b0&"
import script from "./ImportWorkersAction.vue?vue&type=script&lang=js&"
export * from "./ImportWorkersAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports